import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const listGroups = () => axios.get(`${API_BASE_URL}/groups`);

export const createGroup = ({ name, symbols }) =>
  axios.post(`${API_BASE_URL}/groups`, { name, symbols });

export const deleteGroup = (groupId) =>
  axios.delete(`${API_BASE_URL}/groups/${groupId}`);

export const predictGroup = (groupId, horizonMinutes = 30) =>
  axios.post(`${API_BASE_URL}/groups/${groupId}/predict`, { horizon_minutes: horizonMinutes });


